module.exports = __webpack_public_path__ + "static/media/preview-pdf.dba0bd75.png";